var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"matching-card-compact",class:{
    'matching-card-compact--selected': _vm.isSelected,
    'matching-card-compact--faded': _vm.isFaded && !_vm.isDisabled,
    'matching-card-compact--toggle': _vm.isOptionsOpen,
    'matching-card-compact--disabled': _vm.isDisabled,
  }},[_vm._t("action"),_c('div',{staticClass:"matching-card-compact__section-wrapper"},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }